import videojs from 'video.js';
import {
    backwards,
    changeSpeed,
    forwards,
    hideMenus,
    onQualitySelect,
    toggleFullScreen,
    toggleMuted,
    toggleOtherParts,
    togglePause
} from './functions';

export function createDiv(className) {
    const div = document.createElement('div');
    div.className = className;
    return div;
}

export function createIcon(className) {
    const icon = document.createElement('i');
    icon.className = className;
    return icon;
}

export function createBtn(id, iconClass, onClick) {
    const div = createDiv('btn');
    div.id = 'btn-' + id;
    div.onclick = onClick;
    const icon = createIcon(iconClass);
    div.appendChild(icon);
    return div;
}

export function createBtnMenu(id, title, iconClass, items, onItemClick, tooltip = null) {
    const div = createDiv('vjs-oxy-menu');
    const btn = createBtn(
        id,
        iconClass,
        function () {
            const menus = document.querySelectorAll('.vjs-oxy-menu');
            menus.forEach(function (menu) {
                if (menu != div) {
                    menu.classList.remove('show');
                }
            });
            div.classList.toggle('show');
        },
        tooltip
    );
    div.appendChild(btn);
    if (items) {
        const ul = document.createElement('ul');
        ul.id = 'ul-' + id;
        ul.className = 'vjs-oxy-menu-ul';
        const span = document.createElement('span');
        span.className = 'vjs-oxy-menu-title';
        span.innerText = title;
        ul.appendChild(span);
        items.forEach((e) => renderLiList(e, ul, onItemClick));
        div.appendChild(ul);
    }
    return div;
}

export function createBtnSettingsMenu(id, iconClass, items, tooltip = null, firstClick = false) {
    const div = createDiv('vjs-oxy-menu');
    const btn = createBtn(
        id,
        iconClass,
        function () {
            const menus = document.querySelectorAll('.vjs-oxy-menu');
            menus.forEach(function (menu) {
                if (menu != div) {
                    menu.classList.remove('show');
                }
            });
            div.classList.toggle('show');
        },
        tooltip
    );
    div.appendChild(btn);
    if (items) {
        const ul = document.createElement('ul');
        ul.id = 'ul-' + id;
        ul.className = 'vjs-oxy-menu-ul vjs-oxy-menu-ul-settings';
        items.forEach((e) => renderSettingsUlList(e, ul, firstClick));
        div.appendChild(ul);
    }
    return div;
}

export function createTopBar(titleText) {
    const topBar = createDiv('top-bar');
    const title = document.createElement('H1');
    title.className = 'title';
    const text = document.createTextNode(titleText);
    title.appendChild(text);
    const btnBack = createBtn(
        'oxy-top-back',
        'fi fi-rr-angle-left',
        function () {
            window.location.href = filmUrl;
        },
        'برگشت'
    );
    topBar.appendChild(btnBack);
    topBar.appendChild(title);
    return topBar;
}

export function createLeftControls(player, btnPlayPause, currentTimeDisplayRef, durationTimeDisplayRef) {
    const left = createDiv('left');
    const btnForward = createBtn('oxy-forward', 'fi fi-rr-time-forward', forwards(player), 'جلو بردن');
    btnPlayPause.current = createBtn('oxy-play-pause', 'fi fi-rr-play', togglePause(player), 'پخش / توقف');
    const btnBackward = createBtn('oxy-backwards', 'fi fi-rr-time-past', backwards(player), 'عقب بردن');
    const timeDisplay = createTimeDisplay(player, currentTimeDisplayRef, durationTimeDisplayRef);
    left.appendChild(timeDisplay);
    left.appendChild(btnForward);
    left.appendChild(btnPlayPause.current);
    left.appendChild(btnBackward);
    return left;
}

export function createRightControls(player, btnFullScreen, btnMute, otherParts, isSeries = false) {
    const right = createDiv('right');

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    btnFullScreen.current = createBtn('oxy-full-screen', 'fi fi-rr-expand', toggleFullScreen(player), 'تمام صفحه');
    const volumeBarDiv = createVolumeBar(player, btnMute);
    const btnSpeed = createBtnMenu(
        'oxy-speed',
        'سرعت پخش',
        'fi fi-rr-tachometer',
        [
            { title: 'معمولی', item: 1, isSelected: true },
            { title: '1.25', item: 1.25, isSelected: false },
            { title: '1.5', item: 1.5, isSelected: false },
            { title: '2', item: 2, isSelected: false }
        ],
        changeSpeed(player),
        'سرعت پخش'
    );
    const btnDefinition = createBtnMenu(
        'oxy-definition',
        'کیفیت پخش',
        'fi fi-rr-high-definition',
        [{ title: 'خودکار', item: 'auto', isSelected: true }],
        onQualitySelect(player),
        'کیفیت پخش'
    );

    // Only show fullscreen button on desktop
    if (isDesktop) {
        right.appendChild(btnFullScreen.current);
    }
    if (isSeries) {
        const btnList = createBtn(
            'oxy-list',
            'fi fi-rr-rectangle-list',
            function () {
                toggleOtherParts(true, otherParts.current);
            },
            'سایر قسمت ها'
        );
        right.appendChild(btnList);
    }
    right.appendChild(btnSpeed);
    right.appendChild(btnDefinition);
    right.appendChild(volumeBarDiv);
    return right;
}

export function createTimeDisplay(player, currentTimeDisplayRef, durationTimeDisplayRef) {
    const timeDisplay = createDiv('oxy-time-display');
    const currentTimeDisplayComponent = videojs.getComponent('CurrentTimeDisplay');
    currentTimeDisplayRef.current = new currentTimeDisplayComponent(player);
    const durationTimeDisplayComponent = videojs.getComponent('DurationDisplay');
    durationTimeDisplayRef.current = new durationTimeDisplayComponent(player);
    const span = document.createElement('span');
    span.className = 'oxy-time-display-span';
    span.innerText = '/';
    timeDisplay.append(durationTimeDisplayRef.current.el());
    timeDisplay.append(span);
    timeDisplay.append(currentTimeDisplayRef.current.el());
    return timeDisplay;
}

export function createVolumeBar(player, btnMute) {
    const volumeBarDiv = createDiv('oxy-volume-bar');
    btnMute.current = createBtn('oxy-mute', 'fi fi-rr-volume', toggleMuted(player, btnMute), 'صدا');
    volumeBarDiv.appendChild(btnMute.current);
    return volumeBarDiv;
}

export function createSettingsItems() {
    return [
        {
            id: 'sub-color',
            title: 'رنگ زیرنویس',
            key: 'color',
            options: [
                ['#000', 'مشکی', false],
                ['#FF0', 'زرد', false],
                ['#FFF', 'سفید', true],
                ['#F00', 'قرمز', false]
            ],
            onItemClick: null
        },
        {
            id: 'sub-background-color',
            title: 'رنگ پس زمینه زیرنویس',
            key: 'backgroundColor',
            options: [
                ['#000', 'مشکی', true],
                ['#FF0', 'زرد', false],
                ['#FFF', 'سفید', false],
                ['#F00', 'قرمز', false]
            ],
            onItemClick: null
        },
        {
            id: 'sub-opacity',
            title: 'شفافیت پس زمینه زیرنویس',
            key: 'backgroundOpacity',
            options: [
                ['1', 'کامل', true],
                ['0.5', 'نیمه شفاف', false],
                ['0', 'شفاف', false]
            ],
            onItemClick: null
        },
        {
            id: 'sub-size',
            title: 'اندازه زیرنویس',
            key: 'fontPercent',
            options: [
                [0.5, 'کوچک', false],
                [0.75, 'متوسط', true],
                [1.25, 'بزرگ', false],
                [1.5, 'خیلی بزرگ', false]
            ],
            onItemClick: null
        }
    ];
}

export function createTitleBtn() {
    btnTitle = document.createElement('button');
    btnTitle.innerText = 'رد کردن تیتراژ';
    btnTitle.className = 'oxy-title-btn';
    btnTitle.onclick = function () {
        player.currentTime(titleEndTime);
    };
}

export function createPreviouslyBtn() {
    btnPreviously = document.createElement('button');
    btnPreviously.innerText = 'رد کردن آنچه گذشت';
    btnPreviously.className = 'oxy-title-btn';
    btnPreviously.onclick = function () {
        player.currentTime(previouslyEndTime);
    };
}

export function createNextTimeBtn() {
    btnNextTime = document.createElement('button');
    btnNextTime.innerText = 'قسمت بعدی';
    btnNextTime.className = 'oxy-title-btn';
    btnNextTime.onclick = function () {
        goToNextPart();
    };
}

export function createBtnEndTitle() {
    btnEndTitle = document.createElement('button');
    btnEndTitle.innerText = 'رد کردن تیتراژ پایانی';
    btnEndTitle.className = 'oxy-title-btn';
    btnEndTitle.onclick = function () {
        player.currentTime(title2EndTime);
    };
}

export function createOtherPartsElemrnts(otherParts, seasons, changeEpisode, hlsUrl) {
    const div = createDiv('oxy-other-parts-content');
    const topBar = createDiv('oxy-other-parts-content-top');
    const title = document.createElement('span');
    title.innerText = 'لیست قسمت ها';
    const btnBack = createBtn('other-parts-back', 'fi fi-rr-cross', function () {
        toggleOtherParts(false, otherParts.current);
    });
    topBar.appendChild(btnBack);
    topBar.appendChild(title);
    div.appendChild(topBar);
    for (let i = 0; i < seasons.length; i++) {
        const season = createSeasonTitle(i, seasons[i], otherParts, changeEpisode, hlsUrl);
        div.appendChild(season);
    }
    return div;
}

export function createSeasonTitle(_, items, otherParts, changeEpisode, hlsUrl) {
    const div = createDiv('oxy-other-parts-item');
    const title = createDiv('oxy-other-parts-item-title');
    const titleBorder = createDiv('oxy-other-parts-item-title-border');
    const spanSeason = document.createElement('span');
    spanSeason.innerText = items?.title;
    title.appendChild(titleBorder);
    title.appendChild(spanSeason);
    div.appendChild(title);
    const ul = document.createElement('ul');
    for (let i = 0; i < items?.episodes.length; i++) {
        const item = items?.episodes[i];
        const li = document.createElement('li');
        const spanSection = document.createElement('span');
        spanSection.innerText = item.title;

        if (hlsUrl && item.hls === hlsUrl) {
            li.classList.add('selected');
        }

        li.onclick = function () {
            const allSeasonItems = document.querySelectorAll('.oxy-other-parts-item');
            allSeasonItems.forEach((season) => {
                const allLis = season.querySelectorAll('li');
                allLis.forEach((li) => li.classList.remove('selected'));
            });

            li.classList.add('selected');

            toggleOtherParts(false, otherParts.current);
            setTimeout(() => {
                changeEpisode(item);
            }, 400);
        };
        li.appendChild(spanSection);
        ul.appendChild(li);
    }
    div.appendChild(ul);
    return div;
}

export function renderLiList(element, ul, onItemClick) {
    const li = document.createElement('li');
    li.innerText = element.title;
    if (element.isSelected === true) {
        li.className = 'selected';
    }
    li.onclick = function () {
        const listItems = ul.querySelectorAll('li');
        listItems.forEach((item) => {
            item.classList.remove('selected');
        });
        this.classList.add('selected');
        if (onItemClick) {
            hideMenus();
            onItemClick(element.item);
        }
    };
    ul.appendChild(li);
}

export function renderSettingsUlList(e, div, firstClick) {
    const ul = document.createElement('ul');
    ul.id = 'ul-' + e.id;
    ul.className = 'vjs-oxy-menu-setting-ul';
    const span = document.createElement('span');
    span.className = 'vjs-oxy-menu-title';
    span.innerText = e.title;
    e.options.forEach((element) => renderSettingsLiList(element, ul, e.key, e.onItemClick, firstClick));
    div.appendChild(span);
    div.appendChild(ul);
}

export function renderSettingsLiList(element, ul, key, onItemClick, firstClick) {
    const li = document.createElement('li');
    li.innerText = element[1];
    if (element[2] === true) {
        li.className = 'selected';
        if (firstClick) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            onItemClick && onItemClick(element, key);
        }
    }
    li.onclick = function () {
        const listItems = ul.querySelectorAll('li');
        listItems.forEach((item) => {
            item.classList.remove('selected');
        });
        this.classList.add('selected');
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        onItemClick && onItemClick(element, key);
    };
    ul.appendChild(li);
}

